import { render } from "./CommunicationChatContainer.vue?vue&type=template&id=01edc2ac&scoped=true&ts=true"
import script from "./CommunicationChatContainer.vue?vue&type=script&lang=ts"
export * from "./CommunicationChatContainer.vue?vue&type=script&lang=ts"

import "./CommunicationChatContainer.vue?vue&type=style&index=0&id=01edc2ac&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01edc2ac"]])

export default __exports__